module.exports = __webpack_public_path__ + "img/tz1.2433d91e.jpg";